<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
<!--            <el-form-item label="预约号">-->
<!--                <el-input v-model="formInline.orderId" placeholder="预约号" clearable style="width:220px"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="手机号">-->
<!--                <el-input v-model="formInline.mobile" placeholder="手机号" clearable style="width:220px"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="物流单号">-->
<!--            <el-input v-model="formInline.wayNo" placeholder="物流单号" clearable style="width:220px"></el-input>-->
<!--            </el-form-item>-->
            <el-form-item label="OPENID">
                <el-input v-model="formInline.OPENID" placeholder="OPENID" clearable style="width:220px"></el-input>
            </el-form-item>
<!--          <el-form-item label="预约日期">
            <el-date-picker
                v-model=formInline.createDate
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
            <el-form-item label="状态">
            <el-select v-model="formInline.orderStatus"  placeholder="状态">
                <el-option
                        v-for="item in status"
                        :key="item.key"
                        :label="item.value"
                        :value="item.key">
                </el-option>
            </el-select>
            </el-form-item>-->
            <el-form-item>
                <el-button type="success" @click="queryList">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-upload
                    multiple
                    :with-credentials="true"
                    :show-file-list="false"
                    class="upload-demo"
                    :action="importOrderRecoverProductsParam"
                    :on-success="uploadSuccess">
                    <el-button size="small" type="success">上传回收品<i class="el-icon-upload el-icon--right"></i>
                    </el-button>
                </el-upload>
            </el-form-item>
        </el-form>

        <el-table :data="getDataList" stripe border center :size="GCONFIG.styleTableSize" v-show="!showDialog"  v-loading="loading">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
<!--            <el-table-column prop="orderId" label="预约号" width="100"></el-table-column>-->
<!--            <el-table-column prop="activeName" label="活动名" width="110"></el-table-column>-->
<!--            <el-table-column prop="mobile" label="手机号" width="110"></el-table-column>-->
<!--            <el-table-column prop="arriveTime" label="快递上门日期" width="100"></el-table-column>-->
<!--            <el-table-column prop="wayNo" label="快递单号" width="100"></el-table-column>-->
<!--            <el-table-column prop="freightOrderNo" label="运费子单号" width="100"></el-table-column>-->
            <el-table-column prop="nickName" label="用户昵称" width="110"></el-table-column>
            <el-table-column label="用户头像"  width="110">
                <template slot-scope="scope">
                    <el-avatar size="small" :src="scope.row.headImageUrl"></el-avatar>
                </template>
            </el-table-column>
            <el-table-column prop="loveRemain" label="剩余爱心值" width="90"></el-table-column>
<!--            <el-table-column prop="loveShare" label="分享爱心值" width="90"></el-table-column>-->
            <el-table-column prop="loveRecoveryAmount" label="本次回收品总值" width="90"></el-table-column>
            <el-table-column prop="loveTotal" label="爱心值总值" width="90"></el-table-column>
            <el-table-column prop="loveSwapAmount" label="本次兑换物资总值" width="90"></el-table-column>

<!--            <el-table-column prop="siteName" label="站点" width="140"></el-table-column>-->
            <el-table-column prop="recoveryStr" label="回收品" width=""></el-table-column>
            <el-table-column prop="swapStr" label="兑换物资" width=""></el-table-column>

            <el-table-column label="状态" width="120">
                <template slot-scope="scope">
                    <el-tag size="mini" v-if="scope.row.orderSubStatus==0" effect="plain">未提交</el-tag>
                    <el-tag size="mini" v-if="scope.row.orderSubStatus==11" type="success" effect="plain">已提交未支付</el-tag>
                    <el-tag size="mini" v-if="scope.row.orderSubStatus==12" type="Warning" effect="plain">已支付</el-tag>
                    <el-tag size="mini" v-if="scope.row.orderSubStatus==13" type="Info" effect="plain">已叫快递</el-tag>
                    <el-tag size="mini" v-if="scope.row.orderSubStatus==14" type="Info" effect="plain">仓库已录入</el-tag>
                    <el-tag size="mini" v-if="scope.row.orderSubStatus==15" type="Info" effect="plain">已选周边</el-tag>
                    <el-tag size="mini" v-if="scope.row.orderSubStatus==2" type="Info" effect="plain">周边已发货</el-tag>
                </template>
            </el-table-column>

            <el-table-column label="操作" fixed="right" width="220">
                <template slot-scope="scope">
<!--                    <el-button type="warning" size="mini" @click="handleUpdate(scope.row)">核销</el-button>-->
                    <el-button type="warning" size="mini" @click="handleModifyTime(scope.row)">修改时间</el-button>
                    <el-button type="warning" size="mini" @click="handleCancle(scope.row)">取消计划</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap" v-show="!showDialog">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.pageNum"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>
        <el-dialog title="修改上门时间" :visible.sync="showModifyTime" width="30%" center class="main-title">
            <el-form>
                <el-form-item label="上门时间">
                    <el-date-picker
                        v-model="selectTime"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择日期时间">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="showModifyTime = false">取 消</el-button>
                <el-button type="primary" @click="saveNewTime" class="header-btn">保 存</el-button>
            </div>
        </el-dialog>



    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {getVerificationReunionOrderList,VerificationReunionOrder,cancelReunionOrder,importOrderRecoverProducts,modifyReunionOrderArriveTime} from '@/api/api';
    export default {
        data() {
            return {
                showDialog: false,
                showModifyTime: false,
                dialogFormVisible: false,
                dialogFormVisible1: false,
                getDataList: [],// 批次信息
                selectTime: '',
                selectOrderId: '',
                loading: true,
                formInline: {
                    OPENID:'',
                    orderId:'',
                    orderStatus:null,
                    pageNum: 1,
                    pageSize: 10,
                    recordsTotal: 0
                },
                status:[
                    {
                        key:null,
                        value:"全部"
                    },
                {
                    key:0,
                    value:"草稿"
                },{
                    key:1,
                    value:"已提交"
                },{
                    key:2,
                    value:"已核销"
                    },{
                    key:3,
                    value:"已作废"
                    }

                ],
                importOrderRecoverProductsParam:importOrderRecoverProducts
            }
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
            this.queryDataList();
        },
        methods: {

            queryDataList(){
                this.loading = true;
                this.formInline.bindcode="1866011285374504961";//TODO:先写死吧，以后做成可选择2021.10.01
                getVerificationReunionOrderList(this.formInline).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.formInline.recordsTotal = res.data.value.total;
                        this.getDataList = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            //查询
            queryList(){
                this.queryDataList();
                this.formInline.pageNum = 1
            },

            returnHistory(){
                window.history.back()
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.queryDataList();
            },
            handleCurrentChange(val) {
                this.formInline.pageNum = val;
                this.queryDataList();
            },

            //修改事件
            handleUpdate(row) {
                this.$confirm('确认核销, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    VerificationReunionOrder({orderId:row.orderId}).then((res) => {
                        if(res.data.status==200){
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.queryDataList();
                        }else{
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {});
            },
            handleModifyTime(row){
                if(row.orderSubStatus != 11 && row.orderSubStatus != 12){
                    this.$message({
                        showClose: true,
                        message: "当前状态不支持修改上门时间",
                        type: 'error'
                    });
                    return;
                }
                this.showModifyTime = true;
                this.selectOrderId = row.orderId;
                this.selectTime = row.arriveTime;
            },
            saveNewTime(){
                modifyReunionOrderArriveTime({orderId:this.selectOrderId,selectTime:this.selectTime}).then((res) => {
                    if(res.data.status==200){
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.queryDataList();
                        this.showModifyTime = false;
                        this.selectOrderId = '';
                    }else{
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            //取消计划
            handleCancle(row) {
                if(row.orderSubStatus == 0 || row.orderSubStatus == 11){
                    this.$message({
                        showClose: true,
                        message: "用户未支付，不用取消",
                        type: 'error'
                    });
                    return;
                }
                if(row.orderSubStatus == 14 || row.orderSubStatus == 15 || row.orderSubStatus == 2){
                    this.$message({
                        showClose: true,
                        message: "仓库已清点，不能取消",
                        type: 'error'
                    });
                    return;
                }
                var message = '';
                if(row.wayNo != null && row.wayNo != ''){
                    message = '已呼叫快递小哥，让用户自己联系快递取消上门！'
                }
                this.$confirm(message + '取消前需要先退款运费定单, 确定已经退款了吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    cancelReunionOrder({orderId:row.orderId}).then((res) => {
                        if(res.data.status==200){
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.queryDataList();
                        }else{
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {});
            },
            uploadSuccess(res){
                if (res.status == 500) {
                    this.$message({
                        showClose: true,
                        message: res.value,
                        type: 'error'
                    });
                }
                if (res.status == 400) {
                    this.$message({
                        showClose: true,
                        message: "请上传excel文件",
                        type: 'error'
                    });
                }
                if (res.status == 200) {
                    this.$message({
                        showClose: true,
                        message: res.value,
                        type: 'success'
                    });
                }
            }
        }
    }
</script>
<style scoped>
    .customer-id{
        text-decoration: underline;
    }
</style>


// WEBPACK FOOTER //
// src/views/reunion/ReunionOrder.vue